import {
  FileText,
  Landmark,
  type LucideIcon,
} from "lucide-react";
import { privateRoutes, type PrivatePage } from "app/router/private/routes";
import type { UserRole } from "modules/auth/types";

export interface NavigationItem {
  icon: LucideIcon;
  label: string;
  page: PrivatePage;
  path: string;
  activePrefixes?: string[];
}

const emissorNavigationItems: NavigationItem[] = [
  {
    label: "Emissões",
    page: "issuerAssets",
    path: privateRoutes.issuerAssets.path,
    activePrefixes: ["/portal/emissor/ativo"],
    icon: Landmark,
  },
  {
    label: "Propostas",
    page: "issuerProposals",
    path: privateRoutes.issuerProposals.path,
    activePrefixes: ["/portal/emissor/propostas"],
    icon: FileText,
  },
];

const devedorNavigationItems: NavigationItem[] = [
  {
    label: "Emissões",
    page: "debtorAssets",
    path: privateRoutes.debtorAssets.path,
    activePrefixes: ["/portal/devedor/emissao"],
    icon: Landmark,
  },
];

export function getNavItems(role?: UserRole | null): NavigationItem[] {
  if (role === "emissor") {
    return emissorNavigationItems;
  }

  if (role === "devedor") {
    return devedorNavigationItems;
  }

  return [];
}
